import { inject } from '@angular/core';
import { CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { map } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { TokenService } from '../services/token.service';

export const authGuard: CanActivateFn = (_route, state: RouterStateSnapshot) => {
    const authService = inject(AuthService);
    const tokenService = inject(TokenService);
    const router = inject(Router);

    // Tokens en memoire et utilisateur charge — acces immediat
    if (!tokenService.isAccessTokenExpired() && authService.user()) {
        return true;
    }

    // Rechargement de page ou nouvel onglet : le cookie httpOnly porte la session, pas la
    // memoire de l'onglet. On tente toujours la restauration — un visiteur anonyme echoue en
    // un aller-retour et repart vers /login.
    return authService.tryRestoreSession().pipe(
        map((restored) => {
            if (restored) {
                return true;
            }
            // L'URL demandee est transmise au login, qui y renvoie apres connexion : un lien
            // profond partage ne doit pas retomber systematiquement sur le dashboard.
            router.navigate(['/login'], { queryParams: { returnUrl: state.url } });

            return false;
        }),
    );
};
